<script setup></script>
<template>
  <section class="generic">
    <h1>The gift your clients really want, made easy.</h1>
    <p>
      Whether you choose to send your clients a custom selection of small-lot
      gems, impossible-to-attain icons, singular bottlings usually reserved for
      top restaurants, or a Wine Access wine club, know this: They won’t forget
      it. Wine Access delivers a one-of-a-kind wine experience, curated by our
      team of unrivaled experts. It’s the gift of access to the world’s most
      exclusive cellars, and of wine that speaks volumes in a single glass.
    </p>

    <div class="callout">
      <h4>What We Do:</h4>
      <ul>
        <li>
          Provide assistance choosing the perfect selections to fit your budget
          or event.
        </li>
        <li>
          Place all orders—including bulk wine club orders—and oversee
          logistics.
        </li>

        <li>
          Create Personalized gift messages & beautifully curated
          information/tasting sheets for each wine in the shipment.
        </li>
        <li>
          Offer quick and easy access to all of the order and shipping details.
        </li>
      </ul>
      <div>
        <a
          href="https://www.wineaccess.com/go/corporate-gifting-inquiry/"
          class="button"
          style="text-decoration: none; width: fit-content"
          target="_blank"
        >
          &nbsp; &nbsp; &nbsp;Inquire About Corporate Gifting &nbsp; &nbsp;
          &nbsp;</a
        >
      </div>
      <br />
      <p>
        You can also email
        <a href="mailto:gifting@wineaccess.com" class="nowrap underline"
          >gifting@wineaccess.com</a
        >
        or call
        <a href="tel:707-266-7482"> 707-266-7482 </a>
      </p>
    </div>
  </section>
</template>
